$(function () {
  $('[data-slider]').each(function () {
    var $slider = $(this);

    $slider.removeClass('flickity-ready');

    $slider.flickity({
      cellSelector: '.customer-review-column',
      wrapAround: true,
      freeScroll: true,
      contain: true,
      draggable: true,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false,
      accessibility: true
    });

    var flickity = $slider.data('flickity');
    var isPaused = false;
    var tickerSpeed = 1;

    setTimeout(function () {
      if (document.documentElement.contains($slider[0]) && flickity) {
        flickity.reloadCells();
        flickity.resize();
        flickity.reposition();

        $slider.addClass('flickity-ready');
      }
    }, 500);

    $slider.off('.reviewMarquee').on('mouseenter.reviewMarquee', function () {
        isPaused = true;
      })
      .on('mouseleave.reviewMarquee', function () {
        isPaused = false;
      });

    function moveTicker() {
      if (!document.documentElement.contains($slider[0])) {
        return;
      }

      if (!isPaused && flickity && flickity.slides.length && flickity.slideableWidth > 0) {
        flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
        flickity.selectedIndex = flickity.dragEndRestingSelect();

        flickity.updateSelectedSlide();
        flickity.settle(flickity.x);
      }

      window.requestAnimationFrame(moveTicker);
    }

    window.requestAnimationFrame(moveTicker);
  });

  $('[data-logo-slider]').each(function () {
    var $slider = $(this);

    $slider.removeClass('flickity-ready');

    $slider.flickity({
      cellSelector: '.customer-logo-column',
      wrapAround: true,
      freeScroll: true,
      contain: true,
      draggable: true,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false,
      accessibility: true
    });

    var flickity = $slider.data('flickity');
    var isPaused = false;
    var tickerSpeed = 1;

    setTimeout(function () {
      if (document.documentElement.contains($slider[0]) && flickity) {
        flickity.reloadCells();
        flickity.resize();
        flickity.reposition();

        $slider.addClass('flickity-ready');
      }
    }, 500);

    $slider.off('.logoMarquee').on('mouseenter.logoMarquee', function () {
        isPaused = true;
      })
      .on('mouseleave.logoMarquee', function () {
        isPaused = false;
      });

    function moveTicker() {
      if (!document.documentElement.contains($slider[0])) {
        return;
      }

      if (!isPaused && flickity && flickity.slides.length && flickity.slideableWidth > 0) {
        flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
        flickity.positionSlider();
      }
      window.requestAnimationFrame(moveTicker);
    }
    window.requestAnimationFrame(moveTicker);
  });
});